import React from 'react';
import AvailabilityButton from '../common/AvailabilityButton';
import './ProductOptionComponent.css';

const ProductOptionComponent = ({data, innerProps, isFocused, isSelected, showStock = false}) => {
    const product = data.product;
    const code = product.code && product.code > 0 ? product.code : '—';

    const stopSelectPropagation = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    };

    const isAvailabilityTarget = (target) => target?.closest?.('.product-option__availability');

    const openAvailability = (e) => {
        stopSelectPropagation(e);
        e.preventDefault();
        if (data.onAvailabilityClick) {
            data.onAvailabilityClick(product);
        }
    };

    const {
        className: innerClassName,
        onClick: innerOnClick,
        onMouseDown: innerOnMouseDown,
        ...restInnerProps
    } = innerProps;

    const guardSelectHandler = (handler) => (e) => {
        if (isAvailabilityTarget(e.target)) {
            return;
        }
        handler?.(e);
    };

    const optionClassName = [
        'product-option',
        isSelected ? 'product-option--selected' : isFocused ? 'product-option--focused' : '',
    ].filter(Boolean).join(' ');

    return (
        <div
            {...restInnerProps}
            onClick={guardSelectHandler(innerOnClick)}
            onMouseDown={guardSelectHandler(innerOnMouseDown)}
            className={[optionClassName, innerClassName].filter(Boolean).join(' ')}
            data-test="product-async-option"
        >
            <div className="product-option__row">
                <span className="product-option__code">{code}</span>
                <span className="product-option__name">{product.name}</span>
                {showStock && (
                    <span className="product-option__stock">{product.stock}</span>
                )}
                {data.showProductAvailability && (
                    <span className="product-option__availability">
                        <AvailabilityButton
                            title="Disponibilidade"
                            onMouseDown={openAvailability}
                            onPointerDown={openAvailability}
                            onClick={(e) => {
                                stopSelectPropagation(e);
                                e.preventDefault();
                            }}
                            data-test={`product-availability-button-${product.id}`}
                        />
                    </span>
                )}
            </div>
        </div>
    );
};

export default ProductOptionComponent;
